import { staffConditions } from './conditions'
import { staffScenarios } from './steps'
import { staffTexts } from './texts'
import type { IOnboardingModule } from '../../types/IOnboardingModule'

export const staffOnboarding: IOnboardingModule = {
  scenarios: staffScenarios,
  texts: staffTexts,
  conditions: staffConditions,
}
